/* Copyright (c) 2015, Oracle and/or its affiliates. All rights reserved.*/
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

define('application/global/labels',['jquery', 'knockout', 'helpers/stringUtils', "utils/service/rest"], function ($, ko, str, rest) {
  var changeLang = ko.observable();
  changeLang.subscribe(function (newLang) {
    //oj.Config.setLocale(newLang);
    if (localStorage.getItem("lang") !== newLang) {
      oj.Config.setLocale(newLang, function () {
        $('html').attr('lang', newLang);
      });
      console.log("lang changed to : ", newLang);
      localStorage.setItem("lang", newLang);

      if (GLOBAL_CONFIG.useTranslationAPI === true) {
        GLOBAL_UTILS.lang.createLocalTranslation('openid');
      }
    } else {
      console.log('User lang is same');
    }
  });
  var translationItems = ko.observable();

  var createTranslatedold = function createTranslatedold() {
    return function get(key) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'appLabels';
      var placeholderValues = arguments.length > 2 ? arguments[2] : undefined;

      // same as JQuery selector <div id="id-123" class="classes">
      //Check if placeholder values array is passed as second argument
      if (placeholderValues === undefined && $.isArray(type)) {
        placeholderValues = type;
        type = 'appLabels';
      }

      var translatedStr = ""; //Replace place holders with values in translation string

      if ($.isArray(placeholderValues)) {
        translatedStr = oj.Translations.getTranslatedString(type + "." + key);
        var idx = 0;
        translatedStr = translatedStr.replace(/%s/g, function (placeholder) {
          return idx < placeholderValues.length ? placeholderValues[idx++] : placeholder;
        });
      } else if (_typeof(type) === 'object') {
        //Used by Web component (CCA)
        translatedStr = oj.Translations.getTranslatedString(type[key]);
        var _idx = 0;
        translatedStr = translatedStr.replace(/%s/g, function (placeholder) {
          return placeholderValues;
        });
      } else {
        translatedStr = oj.Translations.getTranslatedString(type + "." + key, placeholderValues);
      }

      return translatedStr;
    };
  };

  var createTranslated = function createTranslated() {
    return function get(key) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'appLabels';
      var placeholderValues = arguments.length > 2 ? arguments[2] : undefined;
      // same as JQuery selector <div id="id-123" class="classes">
      var translatedStr = "";

      if (GLOBAL_CONFIG.useTranslationAPI === true) {
        var translationStorage = GLOBAL_UTILS.lang.translationItems();

        if (translationStorage) {
          translatedStr = translationStorage[type][key];

          if ($.isArray(placeholderValues)) {
            var idx = 0;
            translatedStr = translatedStr.replace(/%s/g, function (placeholder) {
              return idx < placeholderValues.length ? placeholderValues[idx++] : placeholder;
            });
          }
        } else {
          translatedStr = key;
        }
      } else {
        //Replace place holders with values in translation string
        if ($.isArray(placeholderValues)) {
          translatedStr = oj.Translations.getTranslatedString(type + "." + key);
          var _idx2 = 0;
          translatedStr = translatedStr.replace(/%s/g, function (placeholder) {
            return _idx2 < placeholderValues.length ? placeholderValues[_idx2++] : placeholder;
          });
        } else {
          translatedStr = oj.Translations.getTranslatedString(type + "." + key, placeholderValues);
        }
      }

      return translatedStr;
    };
  };

  var fetchTranslations = function fetchTranslations() {
    return function getTranslations(moduleName) {
      console.log("getTranslations - fetch ");
      var translations;
      $.ajax(rest.buildServiceUrl(GLOBAL_CONFIG.currentService, '', GLOBAL_CONFIG.serviceContextPath.oidc) + 'translation/ui/' + moduleName + '/' + localStorage.getItem('lang'), {
        type: "GET",
        async: false,
        dataType: "json",
        contentType: "application/json",
        success: function success(response) {
          console.log(response);
          translations = response;
        },
        error: function error() {
          console.log('Error');
        }
      });

      if (translations === undefined) {
        // eslint-disable-next-line no-throw-literal
        throw "Translation data is undefined.";
      }

      ;
      return translations;
    };
  };

  var getTranslationsVersion = function getTranslationsVersion(moduleName) {
    var translations;
    console.log("getTranslationsVersion");
    $.ajax(rest.buildServiceUrl(GLOBAL_CONFIG.currentService, '', GLOBAL_CONFIG.serviceContextPath.oidc) + 'translation/ui/' + moduleName + '/' + localStorage.getItem('lang') + "/version", {
      type: "GET",
      async: false,
      dataType: "json",
      contentType: "application/json",
      success: function success(response) {
        console.log(response);
        translations = response;
      },
      error: function error() {
        console.log('Error');
      }
    });

    if (translations === undefined) {
      return translations;
      throw "Translation data is undefined.";
    }

    ;
    return translations;
  };
  /**
   * Create tranlation name for local storage
   * @param {string} viewName current view name
   * @param {number} timestamp time stamp from meta data
   * @param {string} version translation meta data version
   * @param {string} localization current localization from meta
   */


  var newTranslationNameSpace = function newTranslationNameSpace(viewName, timestamp, version, localization) {
    var newNameSpace = timestamp.toString() + "_" + version + "_" + viewName + "_" + localization;
    console.log('newNameSpace : ', newNameSpace);
    return newNameSpace;
  };
  /**
   * Checks and executes an api call for translation keys and saved to local storage
   * @param {string} viewName viewName current view name
   * @param {object} moduleTranslationSet view module translation object
   * @param {boolean} setLocalStorage create or do not create local storage
   */


  var createLocalStorage = function createLocalStorage() {
    return function createLocalTranslation(viewName, moduleTranslationSet, setLocalStorage) {
      var translationMeta = getTranslationsVersion(viewName);
      console.log('createLocalTranslation : ', createLocalTranslation);
      console.log('translationMeta : ', translationMeta);

      if (translationMeta !== undefined) {
        var localStorageNameSpace = newTranslationNameSpace(viewName, translationMeta.timestamp, translationMeta.version, translationMeta.locale);
        var translationStorage = JSON.parse(localStorage.getItem(localStorageNameSpace));
        var _moduleTranslationSet = null;

        if (translationStorage == null) {
          //Clear all earlier namespaces if any for the locale
          Object.keys(localStorage).forEach(function (key) {
            if (key.endsWith('_' + viewName + '_' + translationMeta.locale) && localStorageNameSpace !== key) {
              localStorage.removeItem(key);
            }
          });
          translationStorage = GLOBAL_UTILS.lang.getTranslations(viewName).translationData;
          localStorage.setItem(localStorageNameSpace, JSON.stringify(translationStorage));
        }

        GLOBAL_UTILS.lang.translationItems(translationStorage);
        /*
        let currentLocale = translationMeta.locale;
        let currentTranslationNamespaces = localStorage.getItem('currentTranslationNamespaces');
        if (currentTranslationNamespaces == null) {
            localStorage.setItem('currentTranslationNamespaces', JSON.stringify({ currentLocale: localStorageNameSpace }));
        } else {
            let jsonStr = localStorage.getItem('currentTranslationNamespaces');
            let jsonObj = JSON.parse(jsonStr);
            let currentNameSpace = jsonObj[currentLocale];
            if (currentNameSpace == null || currentNameSpace == undefined) {
              }
        }
          let translationStorage = JSON.parse(localStorage.getItem(localStorageNameSpace));
        if (translationStorage !== null && translationStorage !== undefined && setLocalStorage === true) {
            console.log('moduleTranslationSet available in browser storage: ');
            moduleTranslationSet = translationStorage;
            console.log('moduleTranslationSet : ', moduleTranslationSet);
        } else {
            try {
                console.log('getTranslations api is being called ');
                moduleTranslationSet = GLOBAL_UTILS.lang.getTranslations(viewName).translationData;
                  localStorage.setItem(localStorageNameSpace, JSON.stringify(moduleTranslationSet));
              } catch (e) {
                console.log("Translation fetch failed.")
            }
        }
        */
      }
    };
  };

  return {
    getold: createTranslatedold(),
    get: createTranslated(),
    getTranslations: fetchTranslations(),
    createLocalTranslation: createLocalStorage(),
    changeLang: changeLang,
    translationItems: translationItems
  };
});
